// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.profile-page-container {
    /* display: flex;
    flex-direction: column;
    justify-content: flex-start; */
    overflow-y: auto;
    height: calc(100dvh - 200px);
    padding: 0px 30px;
  }
  
  
  .MuiTypography-root.profile-title
    { 
    margin-bottom: 10px;
    /* margin-left: 15px; */
    margin-top: 10px;
  }
  
  .profile-avatar-section {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
  }
  
  .MuiAvatar-root.profile-avatar {
    background-color: #69319d;
    color: white;
    width: 56px;
    height: 56px;
  }
  
  .avatar-name {
    color: white;
    font-weight: 500;
  }
  
  .avatar-email {
    color: gray;
  }
  
  .profile-info-section {
    border: 1px solid grey;
    padding: 20px;
    border-radius: 21px;
   
  }
  
  .MuiInputBase-root{
    background-color:#282B4E;
  }
  .MuiTypography-root.section-title {
    color: gray;
    margin-bottom: 15px;
  }
  
  .form-row {
    margin-bottom: 20px;
  }
  
   .textField input {
    color: white !important;
    background: transparent;

  }
  .textField label {
    color: white !important;
    font-size: 14px;
    font-family: var(--font-family-primary);
    font-weight: 400;
    /* line-height: 12px; */
  }
  
  .textField .MuiOutlinedInput-root.Mui-focused fieldset {
    border-color: white;
  } 
  
  
  .textField .MuiOutlinedInput-root {
    border-radius: 8px;
  }
  
  .textField .MuiOutlinedInput-root fieldset {
    border-color: #808080 !important;
  }
  
  .textField .MuiOutlinedInput-root:hover fieldset {
    border-color: #A9A9A9;
  }
  
  .textField .MuiInputLabel-root {
    color: #808080;
  }
  
  .textField .MuiInputLabel-root.Mui-focused {
    color: #808080;
  }
  
  .textField input:-webkit-autofill {
    -webkit-box-shadow: 0 0 0px 1000px #2E335A inset;
    -webkit-text-fill-color: #fff;
  }
  
  .textField input:-webkit-autofill:focus {
    -webkit-box-shadow: 0 0 0px 1000px #2E335A inset;
    -webkit-text-fill-color: #fff;
  } */
  
  
  .MuiSvgIcon-root {
    color: white;
}
  
  .MuiButtonBase-root.submit-button {
    background-color: #69319d;
    font-size: 13px;
    font-weight: 400;
    font-family: var(--font-family-primary);
    border-radius: 8px;
    height: 44px;
  }
  
  .MuiButtonBase-root.button-icon {
    margin-right: 8px;
  }
  .textField .MuiFormHelperText-root {
   height:0px;
   /* margin-bottom: 36px; */
   margin-left: 0px;
  }
  .textField .Mui-disabled  {
    color: #fff !important;
    -webkit-text-fill-color: #fff !important;
    cursor: not-allowed;
    border: none !important;
  }

  @media screen and (min-width: 1024px) {
    .profile-info-section{
       padding-right: 160px;
    padding-left: 70px;
    }
    .profile-page-box{
      width: 70%;
    }
  }
  @media screen and (max-width: 460px) {
  .profile-page-container {
  padding: 0;
}

}
  
  `, "",{"version":3,"sources":["webpack://./src/components/Profile/Profile.css"],"names":[],"mappings":"AAAA;IACI;;kCAE8B;IAC9B,gBAAgB;IAChB,4BAA4B;IAC5B,iBAAiB;EACnB;;;EAGA;;IAEE,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,mBAAmB;EACrB;;EAEA;IACE,yBAAyB;IACzB,YAAY;IACZ,WAAW;IACX,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,gBAAgB;EAClB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,sBAAsB;IACtB,aAAa;IACb,mBAAmB;;EAErB;;EAEA;IACE,wBAAwB;EAC1B;EACA;IACE,WAAW;IACX,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;GAEC;IACC,uBAAuB;IACvB,uBAAuB;;EAEzB;EACA;IACE,uBAAuB;IACvB,eAAe;IACf,uCAAuC;IACvC,gBAAgB;IAChB,uBAAuB;EACzB;;EAEA;IACE,mBAAmB;EACrB;;;EAGA;IACE,kBAAkB;EACpB;;EAEA;IACE,gCAAgC;EAClC;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,gDAAgD;IAChD,6BAA6B;EAC/B;;EAEA;IACE,gDAAgD;IAChD,6BAA6B;EAC/B,EAAE;;;;IAIA,YAAY;AAChB;;EAEE;IACE,yBAAyB;IACzB,eAAe;IACf,gBAAgB;IAChB,uCAAuC;IACvC,kBAAkB;IAClB,YAAY;EACd;;EAEA;IACE,iBAAiB;EACnB;EACA;GACC,UAAU;GACV,yBAAyB;GACzB,gBAAgB;EACjB;EACA;IACE,sBAAsB;IACtB,wCAAwC;IACxC,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA;IACE;OACG,oBAAoB;IACvB,kBAAkB;IAClB;IACA;MACE,UAAU;IACZ;EACF;EACA;EACA;EACA,UAAU;AACZ;;AAEA","sourcesContent":[".profile-page-container {\n    /* display: flex;\n    flex-direction: column;\n    justify-content: flex-start; */\n    overflow-y: auto;\n    height: calc(100dvh - 200px);\n    padding: 0px 30px;\n  }\n  \n  \n  .MuiTypography-root.profile-title\n    { \n    margin-bottom: 10px;\n    /* margin-left: 15px; */\n    margin-top: 10px;\n  }\n  \n  .profile-avatar-section {\n    display: flex;\n    align-items: center;\n    margin-bottom: 10px;\n  }\n  \n  .MuiAvatar-root.profile-avatar {\n    background-color: #69319d;\n    color: white;\n    width: 56px;\n    height: 56px;\n  }\n  \n  .avatar-name {\n    color: white;\n    font-weight: 500;\n  }\n  \n  .avatar-email {\n    color: gray;\n  }\n  \n  .profile-info-section {\n    border: 1px solid grey;\n    padding: 20px;\n    border-radius: 21px;\n   \n  }\n  \n  .MuiInputBase-root{\n    background-color:#282B4E;\n  }\n  .MuiTypography-root.section-title {\n    color: gray;\n    margin-bottom: 15px;\n  }\n  \n  .form-row {\n    margin-bottom: 20px;\n  }\n  \n   .textField input {\n    color: white !important;\n    background: transparent;\n\n  }\n  .textField label {\n    color: white !important;\n    font-size: 14px;\n    font-family: var(--font-family-primary);\n    font-weight: 400;\n    /* line-height: 12px; */\n  }\n  \n  .textField .MuiOutlinedInput-root.Mui-focused fieldset {\n    border-color: white;\n  } \n  \n  \n  .textField .MuiOutlinedInput-root {\n    border-radius: 8px;\n  }\n  \n  .textField .MuiOutlinedInput-root fieldset {\n    border-color: #808080 !important;\n  }\n  \n  .textField .MuiOutlinedInput-root:hover fieldset {\n    border-color: #A9A9A9;\n  }\n  \n  .textField .MuiInputLabel-root {\n    color: #808080;\n  }\n  \n  .textField .MuiInputLabel-root.Mui-focused {\n    color: #808080;\n  }\n  \n  .textField input:-webkit-autofill {\n    -webkit-box-shadow: 0 0 0px 1000px #2E335A inset;\n    -webkit-text-fill-color: #fff;\n  }\n  \n  .textField input:-webkit-autofill:focus {\n    -webkit-box-shadow: 0 0 0px 1000px #2E335A inset;\n    -webkit-text-fill-color: #fff;\n  } */\n  \n  \n  .MuiSvgIcon-root {\n    color: white;\n}\n  \n  .MuiButtonBase-root.submit-button {\n    background-color: #69319d;\n    font-size: 13px;\n    font-weight: 400;\n    font-family: var(--font-family-primary);\n    border-radius: 8px;\n    height: 44px;\n  }\n  \n  .MuiButtonBase-root.button-icon {\n    margin-right: 8px;\n  }\n  .textField .MuiFormHelperText-root {\n   height:0px;\n   /* margin-bottom: 36px; */\n   margin-left: 0px;\n  }\n  .textField .Mui-disabled  {\n    color: #fff !important;\n    -webkit-text-fill-color: #fff !important;\n    cursor: not-allowed;\n    border: none !important;\n  }\n\n  @media screen and (min-width: 1024px) {\n    .profile-info-section{\n       padding-right: 160px;\n    padding-left: 70px;\n    }\n    .profile-page-box{\n      width: 70%;\n    }\n  }\n  @media screen and (max-width: 460px) {\n  .profile-page-container {\n  padding: 0;\n}\n\n}\n  \n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
